import lights from './lights';
import planet from './planet';
import player from './player';

export default {lights, planet, player};


// WEBPACK FOOTER //
// ./src/portfolio/battle-royale/reducers/index.js